import React, { useEffect, useState } from 'react';
import Workshop from './components/Workshop';
import { useLocation } from 'react-router-dom';
import CustomStepper from '../../shared/components/CustomStepper';
import { useDispatch, useSelector } from 'react-redux';
import { setDraft } from '../../app/store/reservationSlice';
import BookStep1 from './components/booking/BookStep1';
import BookStep2 from './components/booking/BookStep2';
import Car from './components/Car';
import BookStep3 from './components/booking/BookStep3';
import { useWindowSize } from '../../shared/hooks/useWindowSize';
import HeaderInfo from '../../shared/components/HeaderInfo';
import WorkshopDetailsSkeleton from './components/laoding_components/WorkshopDetailsSkeleton';
import { useGetWorkshopDetailsQuery } from '../../app/store/api/workshopApi';
import { Box } from '@mui/material';
// import '../styles/styeles.css';

export default function WorkshopPage() {

    const location = useLocation();
    const draft = useSelector((state) => state.reservation.draft);
    const { isDesktop, isTablet } = useWindowSize();
    const dispatch = useDispatch();
    const {data:workshop,isLoading:loading} = useGetWorkshopDetailsQuery(location.pathname);
    const [ activeStep, setActiveStep ] = useState(0);
    const [ showCar, setShowCar ] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setActiveStep(Number(params.get('step')) - 1);
    }, [location]);

    useEffect(() => {
        // if (activeStep > 0 && draft.car) {
        if (draft.car) {
            setShowCar(true);
        } else {
            setShowCar(false);
        }
    }, [activeStep, draft.car]);

    useEffect(() => {
        if (workshop) {            
            dispatch(setDraft({ workshop: workshop }));
        }
    }, [workshop]);

    return (
        <>
        <Box>
            { (isDesktop || isTablet) && 
                <HeaderInfo />
            }
        </Box>
        <Box className='workshop-page'>
            
            <CustomStepper />

            {/* { showCar && activeStep > 0 && <Car /> } */}
            {/* { showCar && activeStep > 0 && (
                <Box sx={{ marginBottom: '20px' }}>
                    <SelectedVehicle />
                </Box>
            ) } */}
            {/* <SelectedVehicle /> */}

            { activeStep === 0 && (loading ? <WorkshopDetailsSkeleton isDesktop={isDesktop} /> : <Workshop workshop={workshop} /> ) }

            { activeStep === 0 && <BookStep1 /> }
            { activeStep === 1 && <BookStep2 /> }
            { activeStep === 4 && <BookStep3 /> }
        </Box>
        </>
        
    );
}